import { ORM } from 'redux-orm';

import {
  Action,
  Attachment,
  Site,
  Protocol,
  DeviceModel,
  Device,
  Label,
  Line,
  Notification,
  Factory,
  FactoryMembership,
  Alarm,
  User,
  Channel,
  Item,
  AlertSetting,
  Diagram,
  SettingPrice,
  Dashboard,
  Alert,
  AlertOccur,
  AlertRes,
  Architecture,
  SettingEmail,
} from './models';

const orm = new ORM({
  stateSelector: (state) => state.orm,
});

orm.register(
  User,
  Factory,
  FactoryMembership,
  Site,
  Protocol,
  DeviceModel,
  Diagram,
  Label,
  Line,
  Device,
  Alarm,
  Attachment,
  Action,
  Notification,
  Channel,
  Item,
  AlertSetting,
  SettingPrice,
  Dashboard,
  Alert,
  AlertOccur,
  AlertRes,
  Architecture,
  SettingEmail,
);

export default orm;
